export function fmtMoney(n, currency = "₹") {
  const v = Number(n || 0);
  return `${currency}${v.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function fmtDate(d, format = "DD/MM/YYYY") {
  if (!d) return "-";
  const date = new Date(d);
  if (isNaN(date)) return "-";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  if (format === "MM/DD/YYYY") return `${mm}/${dd}/${yyyy}`;
  if (format === "YYYY-MM-DD") return `${yyyy}-${mm}-${dd}`;
  return `${dd}/${mm}/${yyyy}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export async function fileToBase64(file, maxBytes = 5 * 1024 * 1024) {
  if (!file) return "";

  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error("Unable to read image"));
    reader.readAsDataURL(file);
  });

  try {
    const compressed = await new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const maxDimension = 1600;
        const scale = Math.min(
          1,
          maxDimension / Math.max(img.width, img.height)
        );

        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(img.width * scale));
        canvas.height = Math.max(1, Math.round(img.height * scale));

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Unable to process image"));
          return;
        }

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        const result = canvas.toDataURL("image/jpeg", 0.75);

        if (!result || result.length < 20) {
          reject(new Error("Unable to compress image"));
          return;
        }

        resolve(result);
      };

      img.onerror = () => reject(
        new Error("Unable to process this photo. Please choose a JPG or PNG photo.")
      );

      img.src = dataUrl;
    });

    return compressed;
  } catch (err) {
    if (file.size <= maxBytes) return dataUrl;
    throw err;
  }
}
